// Prices come from the rendered Shopify settings. Keep unknown quotes explicit.
function bbEstimate({
  mode,
  guests,
  group,
  material,
  beadRates,
  hours,
  beauty,
  beautyRates,
  extras = [],
}) {
  const lines = [];
  const count = Number(guests);
  const validCount = Number.isInteger(count) && count > 0;
  if (mode === "Keychain inquiry")
    lines.push("Standalone keychain bar: contact us for a quote.");
  else if (mode === "Not sure")
    lines.push("Choose an experience to see pricing.");
  else {
    if (mode === "Bracelet Bar" || mode === "Both") {
      if (!validCount || group === "Not sure" || material === "Not sure")
        lines.push(
          "Choose a bead type and group, and enter a whole-number guest count for Bracelet Bar pricing.",
        );
      else if (
        (group === "Up to 6 girls" && count > 6) ||
        (group === "Up to 10 girls" && count > 10) ||
        (group === "More than 10" && count <= 10)
      )
        lines.push(
          "Your group choice does not match the guest count. Update it to see the Bracelet Bar estimate.",
        );
      else {
        const duration = hours === "" ? 1 : Number(hours);
        const base = Number(
          group === "Up to 6 girls" ? beadRates.small : beadRates.medium,
        );
        if (
          !Number.isFinite(duration) ||
          duration < 1 ||
          !Number.isInteger(duration * 2)
        )
          lines.push(
            "For a Bracelet Bar estimate, enter at least 1 hour in half-hour steps. Ask us about other lengths.",
          );
        else if (count > 10 && duration > 1)
          lines.push(
            `${material} Bracelet Bar: $${base}/hour for up to 10, $${beadRates.extra} per additional girl, and $${beadRates.half} per extra half hour. Longer events with more than 10 guests need a confirmed quote.`,
          );
        else {
          const total =
            base +
            Math.max(0, count - 10) * Number(beadRates.extra) +
            (duration - 1) * 2 * Number(beadRates.half);
          lines.push(
            `${material} Bracelet Bar: $${total} for ${duration} ${duration === 1 ? "hour" : "hours"}${hours === "" ? " (one-hour estimate)" : ""}.`,
          );
        }
      }
    }
    if (mode === "Beauty Bar" || mode === "Both") {
      if (beauty === "None" || !validCount)
        lines.push(
          "Choose beauty services and enter a whole-number guest count for Beauty Bar pricing.",
        );
      else
        lines.push(
          `${beauty} Beauty Bar: $${Math.max(count * Number(beautyRates.person), Number(beautyRates.minimum))} for ${count} girls ($${beautyRates.person}/girl; $${beautyRates.minimum} minimum).`,
        );
    }
    if (mode === "Both")
      lines.push(
        "Service estimates shown separately; contact us to confirm combined-party pricing.",
      );
  }
  const selected = extras.filter((e) => e.quantity !== "");
  if (
    selected.some(
      (e) =>
        !Number.isInteger(Number(e.quantity)) ||
        Number(e.quantity) < 0 ||
        (e.attendees && (!validCount || Number(e.quantity) > count)),
    )
  )
    lines.push(
      "Check extras quantities: use whole numbers of 0 or more; recipients cannot exceed the guest count.",
    );
  else if (selected.some((e) => Number(e.quantity) > 0)) {
    const total = selected.reduce(
      (sum, e) => sum + Number(e.quantity) * Number(e.rate),
      0,
    );
    lines.push(
      `Selected extras: $${total} (${selected
        .filter((e) => Number(e.quantity) > 0)
        .map((e) => `${e.quantity} ${e.label}`)
        .join(", ")}), separate from services.`,
    );
  }
  return lines.join(" ");
}

function initBraceletBoss(root = document) {
  root.querySelectorAll(".bb-inquiry").forEach((form) => {
    if (form.dataset.bbReady) return;
    form.dataset.bbReady = "true";
    const find = (name) => form.elements.namedItem(`contact[${name}]`);
    const section = form.closest(".bb-form-section");
    const storageKey = `bb-draft:2026-09-pricing:${section.id}`;
    const draftNotice = form.querySelector("[data-bb-draft-notice]");
    const clientErrors = form.querySelector("[data-bb-client-errors]");
    const fieldErrors = new Map();
    let validationAttempted = false;
    let packageManuallyChosen = false;
    const success = form.querySelector("[data-bb-success]");
    if (success) {
      try {
        sessionStorage.removeItem(storageKey);
      } catch {}
      success.focus();
      return;
    }
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || "null");
      if (saved && Date.now() - saved.time < 3600000) {
        for (const [name, value] of Object.entries(saved.fields)) {
          const input = form.elements.namedItem(name);
          if (
            !input ||
            input.type === "hidden" ||
            input.matches("[data-bb-consent]")
          )
            continue;
          if (input.type === "checkbox") input.checked = value === true;
          else input.value = value;
        }
        if (draftNotice) draftNotice.hidden = false;
        packageManuallyChosen = saved.packageManuallyChosen === true;
      } else sessionStorage.removeItem(storageKey);
    } catch {}
    const persist = () => {
      const fields = {};
      for (const input of form.elements) {
        if (
          !input.name?.startsWith("contact[") ||
          ["hidden", "submit"].includes(input.type) ||
          input.matches("[data-bb-consent]")
        )
          continue;
        fields[input.name] =
          input.type === "checkbox" ? input.checked : input.value;
      }
      try {
        sessionStorage.setItem(
          storageKey,
          JSON.stringify({ time: Date.now(), fields, packageManuallyChosen }),
        );
      } catch {}
    };
    const guestsInput = form.querySelector("[data-bb-guests]");
    const packageInput = form.querySelector("[data-bb-package]");
    packageInput?.addEventListener("change", () => {
      packageManuallyChosen = true;
    });
    const linkedGroup = {
      6: "Up to 6 girls",
      10: "Up to 10 girls",
      large: "More than 10",
    }[new URL(location.href).searchParams.get("bb_group")];
    if (packageInput && linkedGroup) {
      packageInput.value = linkedGroup;
      packageManuallyChosen = true;
    }
    const linkedMaterial = { clay: "Clay", glass: "Glass" }[
      new URL(location.href).searchParams.get("bb_material")
    ];
    if (packageInput && (linkedMaterial || linkedGroup)) {
      form.querySelector("[data-bb-mode]").value = "Bracelet Bar";
      if (linkedMaterial)
        form.querySelector("[data-bb-material]").value = linkedMaterial;
    }
    guestsInput?.addEventListener("input", () => {
      if (packageManuallyChosen) return;
      const guests = Number(guestsInput.value);
      const packageInput = form.querySelector("[data-bb-package]");
      if (!packageInput) return;
      packageInput.value =
        guests > 10
          ? "More than 10"
          : guests > 6
            ? "Up to 10 girls"
            : guests > 0
              ? "Up to 6 girls"
              : "Not sure";
    });
    const update = () => {
      const consent = form.querySelector("[data-bb-consent]");
      if (consent)
        form.querySelector("[data-bb-consent-record]").value = consent.checked
          ? "Permission explicitly granted"
          : "No permission granted";
      form.querySelectorAll("[data-bb-condition]").forEach((group) => {
        const condition = group.dataset.bbCondition;
        const input =
          condition === "beauty"
            ? form.querySelector("[data-bb-beauty]")
            : find(condition);
        const visible = group.dataset.bbNot
          ? input?.value !== group.dataset.bbNot
          : input?.value === group.dataset.bbValue;
        group.hidden = !visible;
        group.querySelectorAll("input,select,textarea").forEach((el) => {
          el.disabled = !visible;
        });
      });
      const packageInput = form.querySelector("[data-bb-package]");
      if (!packageInput) return;
      const modeInput = form.querySelector("[data-bb-mode]");
      const mode = modeInput.value;
      const beautyInput = form.querySelector("[data-bb-beauty]");
      const beauty = beautyInput.value;
      const beautyHelp = form.querySelector("[data-bb-beauty-help]");
      if (beautyHelp) {
        const rate = beautyInput.selectedOptions[0].dataset;
        beautyHelp.textContent =
          beauty === "None"
            ? "Choose a service to see its per-girl price and party minimum."
            : `$${rate.person} per girl · $${rate.minimum} party minimum.`;
      }
      const braceletVisible = mode === "Bracelet Bar" || mode === "Both";
      const beautyVisible = mode === "Beauty Bar" || mode === "Both";
      const two = find("Two beauty services").value;
      const hairVisible =
        beautyVisible &&
        (beauty === "Hair" ||
          beauty === "All three" ||
          (beauty === "Two services" && two.includes("Hair")));
      for (const [selector, visible] of [
        ["[data-bb-bracelet-fields]", braceletVisible],
        ["[data-bb-beauty-fields]", beautyVisible],
        ["[data-bb-two-fields]", beautyVisible && beauty === "Two services"],
        ["[data-bb-hair-fields]", hairVisible],
      ]) {
        form.querySelectorAll(selector).forEach((group) => {
          group.hidden = !visible;
          group.querySelectorAll("input,select").forEach((input) => {
            input.disabled = !visible;
          });
        });
      }
      const guests = form.querySelector("[data-bb-guests]").value;
      form.querySelectorAll("[data-bb-attendees]").forEach((input) => {
        if (Number(guests) > 0) input.max = guests;
        else input.removeAttribute("max");
      });
      const materialInput = form.querySelector("[data-bb-material]");
      const message = bbEstimate({
        mode,
        guests,
        group: packageInput.value,
        material: materialInput.value,
        beadRates: materialInput.selectedOptions[0].dataset,
        hours: form.querySelector("[data-bb-duration]").value,
        beauty,
        beautyRates: beautyInput.selectedOptions[0].dataset,
        extras: [...form.querySelectorAll("[data-bb-extra]")]
          .filter((input) => !input.disabled)
          .map((input) => ({
            label: input.dataset.bbExtra,
            quantity: input.value,
            rate: input.dataset.rate,
            attendees: input.hasAttribute("data-bb-attendees"),
          })),
      });
      form.querySelector("[data-bb-estimate]").textContent = message;
      form.querySelector("[data-bb-estimate-value]").value = message;
      const selection = section.querySelector("[data-bb-selection]");
      if (selection) {
        selection.hidden = mode === "Not sure";
        selection.querySelector("[data-bb-selection-text]").textContent = [
          mode,
          braceletVisible && materialInput.value !== "Not sure"
            ? materialInput.value + " beads"
            : "",
          beautyVisible && beauty !== "None" ? beauty : "",
        ]
          .filter(Boolean)
          .join(" · ");
      }
    };
    const showFieldError = (input) => {
      if (!input.willValidate || input.validity.valid) {
        const error = fieldErrors.get(input);
        if (error) {
          const ids = (input.getAttribute("aria-describedby") || "")
            .split(" ")
            .filter((id) => id && id !== error.id);
          if (ids.length) input.setAttribute("aria-describedby", ids.join(" "));
          else input.removeAttribute("aria-describedby");
          input.removeAttribute("aria-invalid");
          error.remove();
          fieldErrors.delete(input);
        }
        return;
      }
      let error = fieldErrors.get(input);
      if (!error) {
        if (!input.id)
          input.id = `${form.id}-field-${Array.from(form.elements).indexOf(input)}`;
        error = document.createElement("p");
        error.id = `${input.id}-error`;
        error.className = "bb-field-error";
        const container = input.closest(".bb-field, .bb-check");
        if (container?.matches(".bb-check")) container.after(error);
        else (container || input.parentElement).append(error);
        fieldErrors.set(input, error);
        input.setAttribute(
          "aria-describedby",
          [input.getAttribute("aria-describedby"), error.id]
            .filter(Boolean)
            .join(" "),
        );
      }
      error.textContent = input.validationMessage;
      input.setAttribute("aria-invalid", "true");
    };
    const updateErrorSummary = () => {
      if (!clientErrors) return;
      const list = clientErrors.querySelector("ul");
      list.replaceChildren();
      for (const input of form.elements) {
        const error = fieldErrors.get(input);
        if (!error) continue;
        const item = document.createElement("li");
        const link = document.createElement("a");
        link.href = `#${input.id}`;
        const label = input.labels?.[0]?.cloneNode(true);
        label
          ?.querySelectorAll("input, .bb-optional, [aria-hidden]")
          .forEach((el) => el.remove());
        link.textContent = `${label?.textContent.trim().replace(/\s*\*\s*$/, "") || input.name}: ${error.textContent}`;
        link.addEventListener("click", (event) => {
          event.preventDefault();
          let parent = input.parentElement;
          while (parent && parent !== form) {
            if (parent.tagName === "DETAILS") parent.open = true;
            parent = parent.parentElement;
          }
          input.focus();
        });
        item.append(link);
        list.append(item);
      }
      clientErrors.hidden = list.childElementCount === 0;
    };
    const clearCorrectedErrors = () => {
      for (const input of fieldErrors.keys()) showFieldError(input);
      if (validationAttempted) updateErrorSummary();
    };
    form.addEventListener("focusout", (event) => {
      const input = event.target;
      if (
        input.matches("input,select,textarea") &&
        (input.value || validationAttempted)
      ) {
        showFieldError(input);
        if (validationAttempted && !clientErrors?.contains(event.relatedTarget))
          updateErrorSummary();
      }
    });
    form.addEventListener("input", () => {
      update();
      clearCorrectedErrors();
      persist();
    });
    form.addEventListener("change", () => {
      update();
      clearCorrectedErrors();
      persist();
    });
    form.addEventListener(
      "invalid",
      (event) => {
        validationAttempted = true;
        showFieldError(event.target);
        queueMicrotask(updateErrorSummary);
        let parent = event.target.parentElement;
        while (parent && parent !== form) {
          if (parent.tagName === "DETAILS") parent.open = true;
          parent = parent.parentElement;
        }
      },
      true,
    );
    form
      .querySelector("[data-bb-clear-draft]")
      ?.addEventListener("click", () => {
        form.reset();
        try {
          sessionStorage.removeItem(storageKey);
        } catch {}
        for (const [input, error] of fieldErrors) {
          const ids = (input.getAttribute("aria-describedby") || "")
            .split(" ")
            .filter((id) => id && id !== error.id);
          if (ids.length) input.setAttribute("aria-describedby", ids.join(" "));
          else input.removeAttribute("aria-describedby");
          input.removeAttribute("aria-invalid");
          error.remove();
        }
        fieldErrors.clear();
        validationAttempted = false;
        packageManuallyChosen = false;
        if (draftNotice) draftNotice.hidden = true;
        if (clientErrors) clientErrors.hidden = true;
        update();
        form.querySelector("input:not([type=hidden])")?.focus();
      });
    form.addEventListener("submit", persist);
    form.querySelector("[data-bb-errors]")?.focus();
    update();
  });
  root.querySelectorAll(".bb-mobile-menu").forEach((menu) => {
    if (menu.dataset.bbReady) return;
    menu.dataset.bbReady = "true";
    document.addEventListener("click", (event) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
    menu.addEventListener("focusout", (event) => {
      if (event.relatedTarget && !menu.contains(event.relatedTarget))
        menu.open = false;
    });
    menu.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        menu.open = false;
        menu.querySelector("summary").focus();
      }
    });
    menu.querySelectorAll("a").forEach((a) =>
      a.addEventListener("click", () => {
        menu.open = false;
      }),
    );
  });
  root.querySelectorAll(".bb nav a").forEach((link) => {
    const target = new URL(link.href, location.href);
    if (
      !target.hash &&
      target.origin === location.origin &&
      target.pathname === location.pathname &&
      target.searchParams.get("view") ===
        new URL(location.href).searchParams.get("view")
    )
      link.setAttribute("aria-current", "page");
  });
  root
    .querySelectorAll(
      "[data-bb-pick-group], [data-bb-pick-beauty], [data-bb-pick-material]",
    )
    .forEach((link) => {
      if (link.dataset.bbReady) return;
      link.dataset.bbReady = "true";
      link.addEventListener("click", (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)
          return;
        const form = document.querySelector("#bb-event-form .bb-inquiry");
        if (!form) return;
        const mode = form.querySelector("[data-bb-mode]");
        mode.value = link.dataset.bbPickBeauty ? "Beauty Bar" : "Bracelet Bar";
        const input = form.querySelector(
          link.dataset.bbPickGroup
            ? "[data-bb-package]"
            : link.dataset.bbPickMaterial
              ? "[data-bb-material]"
              : "[data-bb-beauty]",
        );
        input.value =
          link.dataset.bbPickGroup ||
          link.dataset.bbPickMaterial ||
          link.dataset.bbPickBeauty;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  root.querySelectorAll(".bb a[href]").forEach((link) => {
    if (link.dataset.bbAnchorReady) return;
    link.dataset.bbAnchorReady = "true";
    link.addEventListener("click", (event) => {
      if (
        event.defaultPrevented ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.altKey ||
        link.target === "_blank"
      )
        return;
      const url = new URL(link.href, location.href);
      if (
        !url.hash ||
        url.origin !== location.origin ||
        url.pathname !== location.pathname ||
        url.searchParams.get("view") !==
          new URL(location.href).searchParams.get("view")
      )
        return;
      const target = document.getElementById(
        decodeURIComponent(url.hash.slice(1)),
      );
      if (!target) return;
      event.preventDefault();
      const heading = target.querySelector("h1,h2,h3") || target;
      heading.setAttribute("tabindex", "-1");
      heading.focus({ preventScroll: true });
      target.scrollIntoView({ block: "start" });
      if (location.hash !== url.hash) history.pushState(null, "", url.hash);
    });
  });
  root.querySelectorAll(".bb-gallery").forEach((gallery) => {
    const dialog = gallery.querySelector("[data-bb-photo-dialog]");
    if (!dialog || dialog.dataset.bbReady) return;
    dialog.dataset.bbReady = "true";
    let opener;
    gallery.querySelectorAll("[data-bb-photo]").forEach((link) => {
      link.addEventListener("click", (event) => {
        if (
          event.ctrlKey ||
          event.metaKey ||
          event.shiftKey ||
          event.altKey ||
          typeof dialog.showModal !== "function"
        )
          return;
        event.preventDefault();
        opener = link;
        const photo = dialog.querySelector("[data-bb-photo-full]");
        photo.src = link.href;
        photo.alt = link.querySelector("img").alt;
        dialog.querySelector("[data-bb-photo-caption]").textContent = link
          .closest("figure")
          .querySelector("figcaption").textContent;
        dialog.showModal();
        document.documentElement.classList.add("bb-photo-open");
      });
    });
    dialog
      .querySelector("[data-bb-photo-close]")
      .addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("close", () => {
      document.documentElement.classList.remove("bb-photo-open");
      opener?.focus({ preventScroll: true });
    });
  });
}
initBraceletBoss();
document.addEventListener("shopify:section:load", (e) =>
  initBraceletBoss(e.target),
);
